module.exports = __webpack_public_path__ + "static/img/zhanganjun.a382245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/zhanganjun.png
// module id = 2EfT
// module chunks = 1